var _circle, _path, _circle2, _path2, _circle3, _circle4, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _mask, _path8, _path9, _path10, _circle5, _path11, _circle6, _path12, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgForgetPasswordIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 216,
    viewBox: "0 0 230 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.076,
    cy: 126,
    r: 90,
    fill: "#FAFDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0165 72.0305C55.0594 65.5911 64.1714 65.5911 66.2143 72.0305L66.5524 73.096C67.7473 76.8625 71.8473 78.8664 75.5533 77.4955L78.6629 76.3451C84.5755 74.1579 89.4933 81.3072 85.3904 86.0934C82.765 89.156 83.7971 93.894 87.4681 95.566C93.2924 98.2189 91.5625 106.916 85.1663 107.138L83.7286 107.188C79.7401 107.326 76.8616 111.095 77.7095 114.995C79.0991 121.387 71.3517 125.82 66.6974 121.224L64.4799 119.034C61.7834 116.372 57.4473 116.372 54.7509 119.034L52.5334 121.224C47.8791 125.82 40.1317 121.387 41.5213 114.995C42.3691 111.095 39.4907 107.326 35.5021 107.188L34.0645 107.138C27.6683 106.916 25.9383 98.2189 31.7627 95.566C35.4336 93.894 36.4657 89.156 33.8404 86.0934C29.7374 81.3072 34.6553 74.1579 40.5678 76.3451L43.6775 77.4955C47.3835 78.8664 51.4834 76.8625 52.6784 73.096L53.0165 72.0305Z",
    fill: "#F1F1F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.6157,
    cy: 96.9231,
    r: 13.8462,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9807 13.7598C98.3322 9.49993 104.36 9.49994 105.712 13.7598L105.935 14.4647C106.726 16.9564 109.438 18.2821 111.89 17.3751L113.947 16.6141C117.858 15.1671 121.112 19.8967 118.397 23.063C116.661 25.089 117.343 28.2233 119.772 29.3295C123.625 31.0845 122.48 36.8378 118.249 36.9847L117.298 37.0177C114.659 37.1093 112.755 39.6027 113.316 42.1826C114.235 46.411 109.11 49.3439 106.031 46.3034L104.564 44.8547C102.78 43.0932 99.9119 43.0932 98.1281 44.8547L96.6611 46.3034C93.5822 49.3439 88.4569 46.411 89.3762 42.1826C89.9371 39.6027 88.0329 37.1093 85.3943 37.0177L84.4433 36.9847C80.2119 36.8378 79.0675 31.0845 82.9205 29.3295C85.349 28.2233 86.0318 25.089 84.295 23.063C81.5807 19.8967 84.8341 15.1671 88.7455 16.6141L90.8026 17.3751C93.2543 18.2821 95.9666 16.9564 96.7571 14.4647L96.9807 13.7598Z",
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.345,
    cy: 30.2272,
    r: 9.15976,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.692,
    cy: 126,
    r: 48.4615,
    fill: "#D3EEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.16 94.8462H74.847C71.7903 94.8462 69.3069 97.3237 69.3069 100.385V135.692C69.3069 138.751 71.7866 141.231 74.8454 141.231H137.153C140.212 141.231 142.692 138.751 142.692 135.692V100.385C142.692 97.3354 140.229 94.8462 137.16 94.8462Z",
    fill: "url(#paint0_linear)",
    stroke: "#39A44F",
    strokeWidth: 5.53846
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.701 138.462H61.6943C59.0178 138.462 56.8457 140.631 56.8457 143.308C56.8457 145.984 59.0154 148.154 61.6919 148.154H151.692C154.368 148.154 156.538 145.984 156.538 143.308C156.538 140.631 154.378 138.462 151.701 138.462Z",
    fill: "#4BDE68"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.3848,
    y: 109.385,
    width: 51.2308,
    height: 15.2308,
    fill: "#61FB80"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.3848,
    y: 109.385,
    width: 51.2308,
    height: 4.15385,
    fill: "#46C35F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0774 112.154L91.6317 116.938H96.6616L92.5923 119.894L94.1467 124.678L90.0774 121.721L86.0081 124.678L87.5624 119.894L83.4931 116.938H88.523L90.0774 112.154Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.154 112.154L102.708 116.938H107.738L103.669 119.894L105.223 124.678L101.154 121.721L97.0843 124.678L98.6386 119.894L94.5693 116.938H99.5992L101.154 112.154Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.232 112.154L113.786 116.938H118.816L114.747 119.894L116.301 124.678L112.232 121.721L108.162 124.678L109.717 119.894L105.647 116.938H110.677L112.232 112.154Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 137.691,
    y: 60.0769,
    width: 30,
    height: 23,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 137.691,
    y: 60.0769,
    width: 30,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.461 78.9231C163.461 75.2508 162.367 71.729 160.419 69.1324C158.472 66.5357 155.83 65.0769 153.076 65.0769C150.322 65.0769 147.68 66.5357 145.733 69.1324C143.785 71.729 142.691 75.2508 142.691 78.9231L153.076 78.9231H163.461Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.461 78.9231C163.461 75.2508 162.367 71.729 160.419 69.1324C158.472 66.5357 155.83 65.0769 153.076 65.0769C150.322 65.0769 147.68 66.5357 145.733 69.1324C143.785 71.729 142.691 75.2508 142.691 78.9231L153.076 78.9231H163.461Z",
    stroke: "#46C35F",
    strokeWidth: 8.30769,
    mask: "url(#path-14-outside-1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.391 78.9231H134.389C132.859 78.9231 131.615 80.1629 131.615 81.6923V99.6923C131.615 101.222 132.855 102.462 134.384 102.462H170.384C171.914 102.462 173.154 101.222 173.154 99.6923V81.6923C173.154 80.1629 171.921 78.9231 170.391 78.9231Z",
    fill: "#EAD623"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.429 92.8094C156.897 92.0265 157.923 90.2367 157.923 88.1538C157.923 85.3499 156.063 83.0769 153.769 83.0769C151.475 83.0769 149.615 85.3499 149.615 88.1538C149.615 90.6091 151.041 92.6574 152.936 93.1287V98.3077H155.429V92.8094Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3077,
    cy: 191.769,
    r: 20.7692,
    fill: "#46C35F",
    stroke: "#D3EEFF",
    strokeWidth: 6.92308
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8071 196.458C21.8071 194.96 21.993 193.765 22.3649 192.875C22.7367 191.985 23.4691 191.01 24.5621 189.951C25.6664 188.88 26.365 188.12 26.658 187.669C27.1087 186.982 27.3341 186.238 27.3341 185.438C27.3341 184.379 27.0693 183.573 26.5397 183.021C26.0213 182.458 25.2551 182.176 24.241 182.176C23.2719 182.176 22.4888 182.452 21.8916 183.004C21.3057 183.545 21.0127 184.283 21.0127 185.218H16.9055C16.928 183.224 17.6041 181.646 18.9337 180.486C20.2746 179.325 22.0437 178.745 24.241 178.745C26.5059 178.745 28.2693 179.32 29.5313 180.469C30.8046 181.618 31.4413 183.224 31.4413 185.286C31.4413 187.123 30.5849 188.931 28.8721 190.712L26.7932 192.757C26.0495 193.602 25.6664 194.836 25.6439 196.458H21.8071ZM21.5198 201.715C21.5198 201.05 21.7282 200.515 22.1451 200.109C22.562 199.692 23.1255 199.484 23.8353 199.484C24.5565 199.484 25.1255 199.698 25.5424 200.126C25.9594 200.543 26.1678 201.072 26.1678 201.715C26.1678 202.335 25.965 202.853 25.5593 203.27C25.1537 203.687 24.579 203.895 23.8353 203.895C23.0916 203.895 22.517 203.687 22.1113 203.27C21.7169 202.853 21.5198 202.335 21.5198 201.715Z",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.692,
    cy: 158.538,
    r: 20.7692,
    fill: "#0999EB",
    stroke: "#D3EEFF",
    strokeWidth: 6.92308
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M203.192 163.227C203.192 161.729 203.378 160.534 203.75 159.644C204.121 158.754 204.854 157.779 205.947 156.72C207.051 155.65 207.75 154.889 208.043 154.438C208.493 153.751 208.719 153.007 208.719 152.207C208.719 151.148 208.454 150.342 207.924 149.79C207.406 149.227 206.64 148.945 205.626 148.945C204.657 148.945 203.874 149.221 203.276 149.773C202.69 150.314 202.397 151.052 202.397 151.988H198.29C198.313 149.993 198.989 148.416 200.319 147.255C201.659 146.094 203.428 145.514 205.626 145.514C207.891 145.514 209.654 146.089 210.916 147.238C212.189 148.387 212.826 149.993 212.826 152.055C212.826 153.892 211.97 155.7 210.257 157.481L208.178 159.526C207.434 160.371 207.051 161.605 207.029 163.227H203.192ZM202.905 168.484C202.905 167.819 203.113 167.284 203.53 166.878C203.947 166.461 204.51 166.253 205.22 166.253C205.941 166.253 206.51 166.467 206.927 166.895C207.344 167.312 207.553 167.842 207.553 168.484C207.553 169.104 207.35 169.622 206.944 170.039C206.538 170.456 205.964 170.664 205.22 170.664C204.476 170.664 203.902 170.456 203.496 170.039C203.102 169.622 202.905 169.104 202.905 168.484Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 72.0762,
    y1: 96.9231,
    x2: 139.922,
    y2: 138.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C35F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgetPasswordIllustration);
export default __webpack_public_path__ + "static/media/forget-password-illustration.ca83de8bff26b62e8432eafdd0e0ab01.svg";
export { ForwardRef as ReactComponent };